import axios, { getHeaders } from "./axios";

export interface CafeStatusResponse {
  id: number;
  isCafeOpen: boolean;
  isBarOpen: boolean;
  baristaOnBreak?: boolean;
  breakWindow?: { start: string; end: string };
}

export const getCafeStatus = async (): Promise<CafeStatusResponse> => {
  const headers = getHeaders();
  const response = await axios.get("/cafe-status", headers);
  return response.data;
};

export const patchStatusCafe = async (
  status: string
): Promise<CafeStatusResponse> => {
  const headers = getHeaders();
  const response = await axios.patch(`/cafe-status/${status}`, {}, headers);
  return response.data;
};

// export const patchStatusBarOpen = async (): Promise<CafeStatusResponse> => {
//   const headers = getHeaders();
//   const response = await axios.patch("/cafe-status/bar-open", {}, headers);
//   return response.data;
// };

// export const patchStatusAllClose = async (): Promise<CafeStatusResponse> => {
//   const headers = getHeaders();
//   const response = await axios.patch("/cafe-status/all-close", {}, headers);
//   return response.data;
// };
